import { render, staticRenderFns } from "./InspectionsWindow.vue?vue&type=template&id=fdd96998&scoped=true"
import script from "./InspectionsWindow.vue?vue&type=script&lang=js"
export * from "./InspectionsWindow.vue?vue&type=script&lang=js"
import style0 from "./InspectionsWindow.vue?vue&type=style&index=0&id=fdd96998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd96998",
  null
  
)

export default component.exports